<template>
  <div :class="rootClasses" :style="rankingRootStyles">
    <ElementControls
      v-if="editing"
      :no-page-break="!pageBreakAllowed"
      @delete="$emit('delete')"
      @duplicate="$emit('duplicate')"
      @page-break="$emit('page-break')"
      @hide="$emit('hide')"
    />
    <div :class="layoutClasses">
      <!-- Label/Question -->
      <div
        v-if="label || description"
        class="formester-label-description-wrapper"
        :style="labelDescriptionWrapperStyles"
      >
        <label
          :class="labelClasses"
          :style="labelStyles"
          :for="item.label + item.id"
          v-html="label"
        />
        <SmartText
          :active="active"
          :editing="editing"
          :item="item"
          :style="descriptionStyles"
          :text="description"
        />
      </div>
      <RankingSortableList
        v-model:ranking="ranking"
        :item="item"
        :editing="editing"
        :dropdown-options="dropdownOptions"
        :option-styles="optionStyles"
        :is-editing-disabled="isEditingDisabled"
      />

      <ErrorMessage :item="item" />
    </div>
  </div>
</template>

<script>
import ElementControls from "@/components/form_fields/shared/element-controls.vue";
import commonStyles from "@/components/form_fields/shared/commonStyles";
import sharedActions from "@/components/form_fields/shared/sharedActions";
import ErrorMessage from "@/components/form_fields/shared/error-message.vue";
import SmartText from "@/components/form_fields/shared/smart-text.vue";
import { cloneJSON } from "@/helpers/utils";
import { set as setItem, isEmpty } from "lodash-es";
import RankingSortableList from "@/components/form_fields/shared/ranking-sortable-list.vue";

export default {
  name: "Ranking",
  components: {
    ErrorMessage,
    ElementControls,
    SmartText,
    RankingSortableList,
  },
  mixins: [commonStyles, sharedActions],
  props: {
    item: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    styling: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pageBreakAllowed: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["delete", "page-break", "duplicate", "hide"],
  computed: {
    rankingRootStyles() {
      return {
        ...this.rootStyles,
        containerType: "normal",
      };
    },
    optionsGroupedById() {
      return this.item.options.reduce((acc, option) => {
        acc[option.id] = option;
        return acc;
      }, {});
    },
    optionsGroupedByLabel() {
      return this.item.options.reduce((acc, option) => {
        acc[option.label] = option;
        return acc;
      }, {});
    },
    itemValue: {
      get() {
        return isEmpty(this.item.value)
          ? cloneJSON(this.item.options)
          : this.item.value.map(
              (id) =>
                this.optionsGroupedById[id] || this.optionsGroupedByLabel[id],
            );
      },
      set(value) {
        setItem(
          this.item,
          "value",
          value.map((o) => o.id),
        );
      },
    },
    options: {
      get() {
        return this.item.options;
      },
      set(value) {
        setItem(this.item, "options", value);
      },
    },
    dropdownOptions() {
      return this.options.map((option, index) => index + 1);
    },
    ranking: {
      get() {
        return this.editing ? this.item.options : this.itemValue;
      },
      set(value) {
        if (this.editing) {
          this.options = value;
        } else {
          this.itemValue = value;
        }
      },
    },
  },
};
</script>
